import { ApiUtility } from "./ApiUtility";

class EpubService {
  route = "/posts";
  aboutRoute = "/api/settings/aboutus?lang=";
  lastpositionRoute = "/api/user/";
  savevivekvanibookmarks = "/api/user/vivekvanimarks?vivekvaniId=";
  getvivekvanibookmarks = "/api/user/vivekvanimarks?bookId=";
  removevanimark = "/api/user/vivekvanimarks?vivekvaniId=";
  removebkmark = "/api/user/bookmarks?bookId=";
  getbkmark = "/api/user/bookmarks?BookId=";
  refreshtoken = "/api/user/RefreshTokenV2";
  highlightsRoute = "api/user/highlights";

  getNavigationDetails = (bookContentType: string, detailId: string) => {
    const type = (bookContentType || "").toLowerCase();

    let endpoint = "/api/Books/navigation-details";
    let payload: any = { bookId: detailId };

    switch (type) {
      case "book":
      case "books":
        endpoint = "/api/Books/navigation-details";
        payload = { bookId: detailId };
        break;
      case "kalyan":
        endpoint = "/api/Kalyans/navigation-details";
        payload = { kalyanId: detailId };
        break;
      case "kalyankalpatru":
      case "kalpatru":
        endpoint = "/api/KalyansKalpataru/navigation-details";
        payload = { kalyanKalpataruId: detailId };
        break;
      case "monthlymagzine":
      case "magazine":
        endpoint = "/api/MonthlyMagazines/navigation-details";
        payload = { monthlyMagazineId: detailId };
        break;
      case "vivekvani":
      case "vivek":
        endpoint = "/api/VivekVanis/navigation-details";
        payload = { vivekVaniId: detailId };
        break;
      default:
        endpoint = "/api/Books/navigation-details";
        payload = { bookId: detailId };
        break;
    }

    return ApiUtility.post(endpoint, payload);
  };

  getAboutData = (lang: string) => {
    return ApiUtility.get(this.aboutRoute + lang);
  };

  SaveLastPositionAndClose = (
    lstposition: string,
    bookId: string,
    last_cfi: string,
    bookfontsize: string,
    navorder?: string,
    bookContentType?: number
  ) => {
    console.log("last_cfi in EpubService:", last_cfi);
    console.log("bookId in EpubService:", bookId);
    console.log("bookfontsize in EpubService:", bookfontsize);
    console.log("navorder in EpubService:", navorder);
    console.log("lstposition in EpubService:", lstposition);
    console.log("bookContentType in EpubService:", bookContentType);

    const url = this.lastpositionRoute + lstposition;

    const payload = {
      bookId: bookId,
      cfi: last_cfi,
      bookType: bookContentType || 0,
      bookFontSize: bookfontsize,
      navOrder: navorder ? Number(navorder) : 0,
      medium: 1 // 1 for web 
    };

    return ApiUtility.post(url, payload);
  };

  savebookmark = (
    bookmarkposition: string,
    bookId: string,
    cfi: string,
    chaptername: string
  ) => {
    return ApiUtility.post(
      this.lastpositionRoute +
      bookmarkposition +
      "?bookId=" +
      bookId +
      "&cfi=" +
      cfi +
      "&chaptername=" +
      chaptername,
      {}
    );
  };

  savevivekvanimark = (
    bookId: string,
    cfi: string,
    chaptername: string
  ) => {
    return ApiUtility.post(
      this.savevivekvanibookmarks +
      bookId +
      "&cfi=" +
      cfi +
      "&chaptername=" +
      chaptername,
      {}
    );
  };

  getvivekvanimark = (bookId: string) => {
    return ApiUtility.get(this.getvivekvanibookmarks + bookId);
  };

  deletevivekmark(bookmarkposition: string, bookId: string, cfi: string) {
    return ApiUtility.delete(this.removevanimark + bookId + "&cfi=" + cfi);
  }

  removebookmark(bookmarkposition: string, bookId: string, cfi: string) {
    return ApiUtility.delete(this.lastpositionRoute + bookmarkposition + "?bookId=" + bookId + "&cfi=" + cfi);
  }

  getbookmark = (bookmarkposition: string, bookId: string) => {
    return ApiUtility.get(this.lastpositionRoute + bookmarkposition + "?bookId=" + bookId);
  };

  getLastPosition(lstposition: string, bookId: string) {
    return ApiUtility.get(this.lastpositionRoute + lstposition + "?bookId=" + bookId);
  }

  refreshexpiredtoken = (
    userId: string,
    medium: 1,
    fcmToken: string
  ) => {
    return ApiUtility.post(
      this.refreshtoken,
      {
        userId: userId,
        medium: 1,
        fcmToken: fcmToken
      },
    );
  };

  saveHighlight = (
    bookId: string,
    cfi: string,
    cfiRange: string,
    content: string,
    color: string,
    chaptername: string
  ) => {
    const url = `${this.highlightsRoute}?bookId=${bookId}&cfi=${cfi}&cfirange=${cfiRange}&content=${encodeURIComponent(content)}&color=${encodeURIComponent(color)}&chaptername=${encodeURIComponent(chaptername)}`;
    return ApiUtility.post(url, {});
  };

  getHighlights = (bookId: string) => {
    return ApiUtility.get(`${this.highlightsRoute}?BookId=${bookId}`);
  };

  removeHighlight = (bookId: string, cfiRange: string) => {
    return ApiUtility.delete(`${this.highlightsRoute}?bookId=${bookId}&cfirange=${cfiRange}`);
  };
}

export default new EpubService();